import styled from 'styled-components';
import { InputText } from 'ui/inputs';
import { Accordion, AccordionHeader } from 'ui/accordion';
import { caption, colors, spacing } from 'ui/theme';

export const PlaceholderInputWrapper = styled.div`
  width: 100%;
`;

export const StyledInputText = styled(InputText)`
  padding-right: ${spacing.double};
  width: 100%;
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Divider = styled.div`
  background-color: ${colors.grey15};
  height: ${spacing.eighth};
  margin-top: ${spacing.plusHalf};
`;

export const StyledLabel = styled.div`
  ${caption};
`;

export const StyledAccordionLabel = styled(AccordionHeader)`
  padding: ${spacing.plusHalf} 0 0 0;
`;

export const StyledAccordion = styled(Accordion)`
  padding: 0;
`;
